// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_SubscriptionSaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /platform-webhooks/subscription-save — the row plus the secret, ONLY when it was just minted. */
import type { PlatformWebhooks_SubscriptionRow } from './PlatformWebhooks_SubscriptionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlatformWebhooks_SubscriptionSaveResponseDados {
row: PlatformWebhooks_SubscriptionRow
created: boolean
secret: string
}

export type PlatformWebhooks_SubscriptionSaveResponse = ApiResponse<PlatformWebhooks_SubscriptionSaveResponseDados>;

registerResponseContract('PlatformWebhooks_SubscriptionSaveResponse', {
  row: {
    type: 'object',
    required: false,
    fields: {
      id:         { type: 'number',  required: true },
      plugin:     { type: 'string',  required: false },
      url:        { type: 'string',  required: false },
      events:     { type: 'array',   required: false },
      enabled:    { type: 'boolean', required: false },
      contract:   { type: 'string',  required: false },
      delivery:   { type: 'string',  required: false },
      managed:    { type: 'boolean', required: false },
      created_at: { type: 'string',  required: false },
      updated_at: { type: 'string',  required: false },
    },
  },
  created: { type: 'boolean', required: true },
  secret:  { type: 'string',  required: false },
})
